import * as moment from 'moment';

export class SearchResult {
    constructor(json?: any) {
        this.playerRNID = json && json.player_id || null;
        this.firstName = json && json.first_name || null;
        this.lastName = json && json.last_name || null;
        this.email = json && json.email || null;
        this.jersey = json && json.jersey_number || null;
        this.position = json && json.position || null;
        this.positionShort = json && json.position_short || null;
        this.appUserID = json && json.app_user_id || null;
        this.profileImage = json && json.profile_image_url || null;
        this.profileDescription = json && json.profile_description || null;
        this.isRecruit = json && json.is_recruit_member || false;
        this.isConnected = json && json.is_connected || false;
        this.conversationSID = json && json.conversation_sid || false;
        this.matchPercent = json && json.match_percent || null;
        this.isRecruitEligible = json && json.is_recruit_eligible_player || false;
        this.curTeamName = json && json.cur_team_name || null;
        this.homeTown = json && json.home_town || null;
        this.height = json && json.height || null;
        this.weight = json && json.weight || null;
        this.shoots = json && json.shoots || null;
        this.catches = json && json.catches || null;
        this.gp = json && json.gp || null;
        this.g = json && json.g || null;
        this.a = json && json.a || null;
        this.pts = json && json.pts || null;
        this.isScout = json && json.is_scout || false;

        if(json && json.birth_date) {
            this.birthdate = moment(json.birth_date);
        }
    }

    playerRNID: number;
    firstName: string;
    lastName: string;
    email: string;
    jersey: string;
    position: string;
    positionShort: string;
    appUserID: number;
    profileImage: string;
    profileDescription: string;
    isRecruit: boolean;
    isConnected: boolean;
    conversationSID: string;
    birthdate: moment.Moment;
    matchPercent: number;
    isRecruitEligible: boolean;
    curTeamName: string;
    homeTown: string;
    height: string;
    weight: string;
    shoots: string;
    catches: string;
    gp: number;
    g: number;
    a: number;
    pts: number;
    isScout: boolean;
}